import { useState } from "react";
import Navigation from "./components/UI/Navigation";
import MobileNavigation from "./components/UI/MobileNavigation";
import Intro from "./components/sections/Intro";
import About from "./components/sections/About";
import Technologies from "./components/sections/Technologies/Technologies";
import Projects from "./components/sections/Projects/Projects";
import Contact from "./components/sections/Contact";
import "./styles/App.css";

function App() {
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen((prevState) => !prevState);
  };

  return (
    <div>
      <button onClick={toggleNav} className="nav-btn">
        <i className="fa-solid fa-bars"></i>
      </button>
      <Navigation />
      <MobileNavigation navOpen={navOpen} closeNav={toggleNav} />
      <div className="main-container">
        <Intro />
        <About />
        <Technologies />
        <Projects />
        <Contact />
      </div>
    </div>
  );
}

export default App;
